import React from "react";
import "@/styles/design-system.css";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from 'react-helmet-async';
import { Toaster } from "@/components/ui/sonner";
import { Header } from "@/components/Header";
import { HeroSection } from "@/components/HeroSection";
import { EvbSection } from "@/components/EvbSection";
import { ServicesSectionNew } from "@/components/ServicesSectionNew";
import { WhyChooseUs } from "@/components/WhyChooseUsPremium";
import { ReviewsSection } from "@/components/ReviewsSectionPremium";
import { HowItWorks } from "@/components/HowItWorksPremium";
import { ContactSection } from "@/components/ContactSection";
import { LeadForm } from "@/components/LeadForm";
import { Footer } from "@/components/Footer";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { EvbNummerPage } from "@/pages/EvbNummerPage";
import { VersicherungPage } from "@/pages/VersicherungPage";
import { ImpressumPage } from "@/pages/ImpressumPage";
import { DatenschutzPage } from "@/pages/DatenschutzPage";

const Home = () => {
  return (
    <div className="min-h-screen overflow-x-hidden">
      <Header />
      <main>
        <HeroSection />
        <EvbSection />
        <ServicesSectionNew />
        <WhyChooseUs />
        <ReviewsSection />
        <HowItWorks />
        <ContactSection />
        <LeadForm />
      </main>
      <Footer />
      <WhatsAppButton />
    </div>
  );
};

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/evb-nummer" element={<EvbNummerPage />} />
            <Route path="/versicherung" element={<VersicherungPage />} />
            <Route path="/impressum" element={<ImpressumPage />} />
            <Route path="/datenschutz" element={<DatenschutzPage />} />
          </Routes>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </div>
    </HelmetProvider>
  );
}

export default App;
